import { HowItWorks5StepsDetailed } from "./HowItWorks5StepsDetailed";
import { cardsDetailed5StepsConfig } from "./config";

export { HowItWorks5StepsDetailed, cardsDetailed5StepsConfig };
